module.exports = __webpack_public_path__ + "img/2_Wawa_Screen_3.9f9dedda.jpg";